import React from "react";
import { useTranslation } from "react-i18next";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";

const StartTodayCom = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  let language = localStorage.getItem("i18nextLng");

  return (
    <div
      className={
        location?.pathname === "/faq" ||
        location?.pathname === "/dashboard/faq" ||
        location.pathname === "/instrumentbrada/faq"
          ? "setFaqbg"
          : ""
      }
    >
      <div
        className={
          dashboardFooter === false
            ? "upr_text"
            : "upr_text dashbord_upr dashinvoice"
        }
      >
        {!user && (
          <section
            className={
              dashboardFooter === false
                ? "invoice new_sctn"
                : "dashboard_invoice new_sctn New_dashbord_clss space"
            }
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="invoicing-section">
                    {/* <img src={invoiceFooterLogo} /> */}
                    <h2
                      className={
                        dashboardFooter === false ? "mb-0 " : "text-white mb-0"
                      }
                    >
                      {t("Invoicing without a company")}
                    </h2>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="invoice-group text-md-right text-left">
                    <div className="invoicing d-flex align-items-center justify-content-end">
                      <Link
                        to={
                          language === LOCALES.EN_US
                            ? `/emailregister?lang=${LOCALES.EN_US}`
                            : `/e-postregister?lang=${LOCALES.SV_SE}`
                        }
                        className={
                          dashboardFooter === false
                            ? "mb-0 d-inline mr-2"
                            : "text-white new"
                        }
                        style={{ textDecoration: "underline" }}
                      >
                        <h2
                          className="new_h2 nw_fnt_style d-flex align-items-center"
                          style={{ textDecoration: "underline" }}
                        >
                          {t("START INVOICING TODAY")}
                          <BsArrowRight className="cursor-pointer arrow" />
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default StartTodayCom;
